
import React, { useState } from 'react';
import { MIDIMessageData } from '../types';
import MIDIDebugger from './MIDIDebugger';

interface MidiPanelProps {
  midiInputs: MIDIInput[];
  selectedMidiInputId: string;
  onSelectMidiInput: (id: string) => void;
  lastMidiMessage: MIDIMessageData | null;
}

const MidiPanel: React.FC<MidiPanelProps> = ({ midiInputs, selectedMidiInputId, onSelectMidiInput, lastMidiMessage }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleDisconnect = () => {
    onSelectMidiInput('');
  };

  return (
    <div className="border border-gray-700 rounded-lg p-3 min-w-[300px]" data-debug-id="Level-1:MidiPanel">
      <div className="flex justify-between items-center" data-debug-id="Level-2:MidiPanel-Header">
        <h3 className="text-sm font-bold text-gray-400 uppercase tracking-wider" data-debug-id="Level-3:MidiPanel-Title">MIDI Input</h3>
        <button 
            onClick={() => setIsExpanded(!isExpanded)} 
            className="p-1 text-gray-400 hover:text-white rounded-md hover:bg-gray-700/50" 
            aria-expanded={isExpanded} 
            aria-controls="midi-debugger-content"
            aria-label={isExpanded ? "Collapse MIDI monitor" : "Expand MIDI monitor"}
            data-debug-id="Level-3:MidiPanel-ExpandButton"
        >
            <svg xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 transition-transform duration-200 ${isExpanded ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" data-debug-id="Level-4:MidiPanel-ExpandIcon">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
        </button>
      </div>
      <div className="mt-2" data-debug-id="Level-2:MidiPanel-Content">
          {midiInputs.length > 0 ? (
            <div className="space-y-2">
              <select
                  value={selectedMidiInputId}
                  onChange={(e) => onSelectMidiInput(e.target.value)}
                  className="bg-gray-700 border border-gray-600 rounded-md p-2 text-white text-sm focus:ring-2 focus:ring-cyan-500 focus:outline-none w-full"
                  data-debug-id="Level-3:MidiPanel-DeviceSelect"
              >
                  <option value="">-- No device selected --</option>
                  {midiInputs.map(input => (
                      <option key={input.id} value={input.id} data-debug-id={`Level-4:MidiDevice-${input.id}`}>
                          {input.name} ({input.manufacturer})
                      </option>
                  ))}
              </select>
              {selectedMidiInputId && (
                <button
                  onClick={handleDisconnect}
                  className="w-full bg-red-600 hover:bg-red-700 text-white text-xs py-1.5 px-3 rounded-md transition-colors"
                >
                  Disconnect MIDI Device
                </button>
              )}
            </div>
          ) : (
              <p className="text-sm text-gray-400" data-debug-id="Level-3:MidiPanel-NoDevices">No MIDI devices found.</p>
          )}
          <div 
            id="midi-debugger-content" 
            className={`transition-all duration-300 ease-in-out overflow-hidden ${isExpanded ? 'max-h-40' : 'max-h-0'}`}
            data-debug-id="Level-3:MidiPanel-DebuggerContainer"
          >
            <MIDIDebugger message={lastMidiMessage} />
          </div>
      </div>
    </div>
  );
};

export default MidiPanel;